/** Treat phone formatter placeholder as empty (optional field). */
export function normalizeOptionalPhone(phone?: string): string | undefined {
  const trimmed = (phone ?? '').trim();
  if (!trimmed || trimmed === '+92-' || trimmed === '+92') {
    return undefined;
  }
  return trimmed;
}

export function normalizeOptionalEmail(email?: string): string | undefined {
  const trimmed = (email ?? '').trim();
  return trimmed || undefined;
}

export function normalizeOptionalText(value?: string): string | undefined {
  const trimmed = (value ?? '').trim();
  return trimmed || undefined;
}

export function summarizeFieldErrors(errors: Record<string, string>): string {
  const messages = Object.values(errors).filter(Boolean);
  if (messages.length === 0) {
    return 'Please fix the highlighted fields.';
  }
  if (messages.length === 1) {
    return messages[0];
  }
  return `Please fix: ${messages.join(' ')}`;
}

/** Map API / network errors to user-facing donor form messages. */
export function formatDonorApiError(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const err = error as {
      message?: string;
      response?: { data?: { message?: string }; status?: number };
      code?: string;
    };
    if (err.response?.data?.message) {
      return err.response.data.message;
    }
    if (err.response?.status === 409) {
      return fallback.includes('guest')
        ? 'A guest donor with this phone number already exists.'
        : 'A donor with this CNIC or phone already exists.';
    }
    if (err.response?.status === 400) {
      return err.message && err.message !== 'Request failed'
        ? err.message
        : 'Some fields are invalid. Check CNIC, phone (+92-XXXXXXXXXX), and email format.';
    }
    if (err.code === 'ERR_NETWORK') {
      return 'Network error. Check your connection and try again.';
    }
    if (err.message && !err.message.startsWith('Request failed')) {
      return err.message;
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
